export const UnenrollT2CConfirmModalBodyText = `
  You’ll no longer be able to authorize Remote Purchases using Text2Confirm and all Project lines of credit will be unenrolled.`;

export const UnenrollT2CConfirmModalHeaderText = `Do You Want To Stop Text2Confirm Purchase Approvals For This Primary Shop Line of Credit?`;
